export function equalizePricingHeights($swiperRoot) {
  if (typeof window === 'undefined') return

  const $ = window.$
  if (!$ || !$swiperRoot?.length || !$.fn.matchHeight) return

  const $items = $swiperRoot.find('.pricing_item')
  if (!$items.length) return

  $.fn.matchHeight._maintainScroll = true
  $items.matchHeight('remove')
  $items.matchHeight({ byRow: true })
}

export function refreshAllPricingHeights() {
  if (typeof window === 'undefined' || typeof window.$ === 'undefined') return

  window.$('.pricing-swiper').each(function refreshPricingRow() {
    equalizePricingHeights(window.$(this))
  })
}
